import React from 'react';
import {
  AccordingContainer,
  AccordingImage,
  AccordingText,
  AccordingWrapper,
  ContentWrapper,
  AccordingText2,
  TextWrapper,
} from './accordingElements';

const index = ({
  Image, Text, Text2, Bg,
}) => (
  <AccordingContainer>
    <AccordingWrapper>
      <ContentWrapper Bg={Bg}>
        <AccordingImage alt="Logo" src={Image} />
        <TextWrapper>
          <AccordingText>
            {Text}
          </AccordingText>
          <AccordingText2>
            {Text2}
          </AccordingText2>
        </TextWrapper>
      </ContentWrapper>
    </AccordingWrapper>
  </AccordingContainer>
);

export default index;
